import React from "react";
import { ICONS } from "../../Constants/icons";
import { ImageView } from "./ImageView";
import { navigator } from "../../Controllers/Navigator";


class LogoView extends React.Component {

    render() {
        return <div className="logo-view" onClick={()=>navigator().navigate('/')}>
            {/* <ImageView source={ICONS.logo} withoutLoader/> */}
            <div className="logo-text">
                Wyens
            </div>
        </div>
    }
}

export { LogoView }